// extracted by mini-css-extract-plugin
module.exports = {"MDEditor":"_2_rgd"};